import {
  create_set_record,
  get_project_set_by_id,
  query_set_record_list,
} from '@/api/mjstore-model';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model2/mjstore/mjstore-setrecord-config';
import column_config from '@/components/page-model2/mjstore/mjstore-setrecord-column-config';

import { reactive } from 'vue';

const None = null;
// const True = true;
// const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
const { baseColumns, newSlotList } = column_config(current_org);

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'order_code',
      label: '套餐编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写套餐编号',
    },
    {
      type: 'remotemodal',
      name: 'customer_id',
      label: '会员姓名',
      disabled: false,
      placeholder: '请选择会员姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
    {
      type: 'remotemodal',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
    {
      type: 'remoteselect',
      name: 'project_set_id',
      label: '套餐名称',
      disabled: false,
      placeholder: '请选择套餐名称',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-projectset',
    },
    {
      type: 'remoteselect',
      name: 'cxzc_id',
      label: '促销政策',
      disabled: false,
      placeholder: '请选择促销政策',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-policy',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'datepicker',
      name: 'date',
      label: '下套餐日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM-DD HH:mm:ss',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      showTime: true,
      placeholder: '请选择下套餐日期',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    order_code: null,
    customer_id: null,
    staff_id: null,
    project_set_id: null,
    cxzc_id: null,
    shop_id: current_shop?.id,
    date: null,
  }),
};
const search_options = {};

const edit_model_config = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [],
  rules: {
    customer_id: [{ required: true, message: '请填输入会员姓名' }],
    project_set_id: [{ required: true, message: '请填输入套餐名称' }],
    date: [{ required: true, message: '请填输入下套餐日期' }],
    shop_id: [{ required: true, message: '请填输入执行门店' }],
  },
  watch: {
    project_set_id: (data: any) => {
      if (data['project_id'] > 0) {
        get_project_set_by_id({
          org_id: current_org.id,
          project_set_id: Number(data.id),
        }).then((res: any) => {
          data['price'] = res.price;
        });
      }
    },
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    order_code: null,
    customer_id: null,
    project_set_id: null,
    price: null,
    czje: null,
    flje: null,
    zjfl: null,
    zjje: null,
    date: null,
    cxzc_id: null,
    shop_id: current_shop?.id,
    staff_id: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '套餐购买记录管理',
  addModalTitle: '新建套餐购买记录',
  updateTitle: '修改套餐购买记录',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    id: 'id',
  },
  delete: {
    id: 'id',
  },
  recover: {
    id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    id: 'id',
  },
};

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_set_record_list,
    addData: create_set_record,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
